module.exports = __webpack_public_path__ + "img/landscape-666927_1280.9e6c8a1a.jpg";